module.exports = __webpack_public_path__ + "static/media/pg_tidepool_tablet_charles_nye.29824216.png";